import React, { useState } from "react";
import { Nav } from "react-bootstrap";
import "./user.css";
import { Link, useNavigate } from "react-router-dom";

const UserSidebar = () => {
  const [activeTab, setActiveTab] = useState("Dashboard");
  const [isOpen, setIsOpen] = useState(false);

  const navigate = useNavigate();
  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if (window.innerWidth < 768) setIsOpen(false);
  };
  const logout = () => {
    const confirm = window.confirm("Are you sure? you want to logout?");
    if (confirm) {
      localStorage.removeItem("user");
      navigate("/");
    }
  };

  const toggleSidebar = () => setIsOpen(!isOpen);
  // const tab = urlParams.get("tab") || "dashboard";

  return (
    <div>
      <button
        className="btn btn-primary d-md-none toggle-btn shadow"
        onClick={toggleSidebar}
      >
        <span className="account-menu">
          Account Menu <i className="bi bi-list fs-2"></i>
        </span>
      </button>

      <div
        className={`d-flex flex-column bg-white user-side-bar ${
          isOpen ? "open" : ""
        }`}
      >
        <Nav className="flex-column">
          {[
            { name: "Dashboard", icon: "bi-grid-3x2-gap", link: "/dashboard" }
            ,
            {
              name: "All Tests",
              icon: "bi bi-card-list",
              link: "/dashboard?tab=allTest",
            },
            {
              name: "My Tests",
              icon: "bi-card-checklist",
              link: "/dashboard?tab=myTest",
            },
            {
              name: "My Subscription",
              icon: "bi-wallet",
              link: "/dashboard?tab=my-subscription",
            },
            {
              name: "Courses",
              icon: "bi-camera-video",
              link: "/dashboard?tab=interviews",
            },
            {
              name: "UCAT Calculator",
              icon: "bi-calculator-fill",
              link: "/dashboard?tab=calculator",
            },
            {
              name: "Payments",
              icon: "bi-wallet",
              link: "/dashboard?tab=payments",
            },
            
            {
              name: "Account Details",
              icon: "bi-person",
              link: "/dashboard?tab=account",
            },
          ].map((tab, index) => (
            <Nav.Item
              key={index}
              className={`sideBar-item p-0 ${
                activeTab === tab.name ? "active-tab" : ""
              }`}
              onClick={() => handleTabClick(tab.name)}
            >
              <Link to={tab.link} className="d-flex align-items-center nav-link p-3">
                <i className={`bi ${tab.icon} me-2`}></i>
                {tab.name}
              </Link>
            </Nav.Item>
          ))}
          <Nav.Item className={`sideBar-item`} onClick={() => logout()}>
            <div className="d-flex align-items-center ms-1" role="button">
              <i className={`bi bi-box-arrow-right me-1`}></i>
              Logout
            </div>
          </Nav.Item>
        </Nav>
      </div>
    </div>
  );
};

export default UserSidebar;
